import { render, staticRenderFns } from "./BoardNotFound.vue?vue&type=template&id=bd818770&scoped=true&"
import script from "./BoardNotFound.vue?vue&type=script&lang=js&"
export * from "./BoardNotFound.vue?vue&type=script&lang=js&"
import style0 from "./BoardNotFound.vue?vue&type=style&index=0&id=bd818770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd818770",
  null
  
)

export default component.exports